export default "__VITE_ASSET__i69mZlOB__"